import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

// Consistent section intro used across the page for uniform content placement.
export function SectionHeading({ index, overline, title, align = "left", className = "", overlineClassName = "" }) {
  const { lang } = useLang();
  const isHi = lang === "hi";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`flex flex-col ${align === "center" ? "items-center text-center" : "items-start"} ${className}`}
    >
      <div className="flex items-center gap-3 mb-4">
        {index && <span className="font-mono text-xs text-muted-foreground">{index}</span>}
        <span className="w-8 h-px bg-[#FFCC00]" />
        <span className={`label-overline text-muted-foreground ${overlineClassName}`}>{overline}</span>
      </div>
      {title && (
        <h2 className={`font-black text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-tight max-w-4xl ${isHi ? "font-hindi" : "font-sans"}`}>
          {title}
        </h2>
      )}
    </motion.div>
  );
}
